module.exports = __webpack_public_path__ + "static/img/son12.7ab6b717.png";